import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { GlobalAlarmBanner } from '@/components/GlobalAlarmBanner';
import { PipAlarmButton } from '@/components/AlarmPipWindow';

export function DashboardLayout() {
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <GlobalAlarmBanner />
        {/* PipAlarmButton mounts globally so auto-open works on any page */}
        <PipAlarmButton />
        <Outlet />
      </main>
    </div>
  );
}
